export * from './common'

// Opening dollar amount on the buy screen.
//
// The screen used to open at whatever the customer could AFFORD, which collapsed
// to the minimum quantity — displaying "BUY: $0.00" — for anyone with a low or
// NEGATIVE balance. Capping by affordability was wrong anyway: checkout collects
// a top-up, so a customer with no cash can still buy.
// Requested by Cam, 2026-08-03.
export const DEFAULT_BUY_AMOUNT = '100'
